<template>
  <div>
    <NBar title="代理商帐号列表" :top="true"/>
    <list-loading ref="list" :data.sync="list" :page.sync="page" :limit.sync="limit" @loadlist="getData"
                  :is-show-mod="true">
      <div slot="list" v-for="(item,index) in list" :key="index" class='item'>
        <div class='content'>
          <div class='title'>
            <span class='name'><img style="width: 25px;height: 25px;" :src="listIcon.agent_office_supplies">{{
                item.name
              }}</span>
            <span class="num">{{ item.addTime }}</span>
          </div>
        </div>
        <div class='edit'>
          <div class='def'>
            帐号: {{ item.username }}
          </div>
          <div class='btn-groups'>
            <div class='edit-btn' @click='goAgentSet(item)'>
              <img :src='listIcon.address_icon_edit'/>
              <span>编辑</span>
            </div>
            <!--            <div class='btn' @click='delTap(item)'>-->
            <!--              <img :src='listIcon.address_icon_delect'/>-->
            <!--              <span>删除</span>-->
            <!--            </div>-->
          </div>
        </div>
      </div>
    </list-loading>
    <div class="bottom">
      <nut-button style="margin: 0 15px;border-radius: 5px;width:92%;" @click="goAgentSet">添加</nut-button>
    </div>
  </div>
</template>

<script>
/**
 * 代理商帐号设置
 */
export default {
  name: 'AgentList',
  data() {
    return {
      listIcon: {
        address_icon_edit: require ('@/resource/img/device/address_icon_edit.png'),
        address_icon_delect: require ('@/resource/img/device/address_icon_delect.png'),
        agent_office_supplies: require ('@/resource/img/device/svg/agent-office-supplies.svg')
      },
      page: 1,
      limit: 20,
      list: []
    }
  },
  mounted() {
    this.getData ()
  },
  methods: {
    getData() {
      let data = {
        userType: 1,
        page: this.page,
        limit: this.limit
      }
      this.$api.post ({
        url: '/device/api/device/device-account/list',
        data: data,
        loading: false
      }).then (res => {
        this.$refs.list.setRes (res)
      })
    },
    goAgentSet(item) {
      this.$router.push ({
        path: '/device/AgentSet',
        query: {
          data: encodeURIComponent (JSON.stringify (item))
        }
      })
    }
  }
}
</script>

<style scoped>
.item {
  display: flex;
  flex-direction: column;
  margin-top: 10px;
}

.item .content {
  background: #fff;
}

.item .content .title {
  margin: 0 12px;
  display: flex;
  height: 40px;
  line-height: 40px;
  align-items: center;
  justify-content: space-between;
}

.item .content .title .name {
  font-size: 18px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(0, 0, 0, 1);
  display: flex;
  align-items: center;
}

.item .content .title .num {
  font-size: 11px;
  height: 20px;
  line-height: 20px;
  padding: 0 4px;
  border-radius: 5px;
  color: #8e8e8e;
  margin-left: 10px;
}

.item .content .addr {
  display: block;
  line-height: 16px;
  margin: 0 12px;
  color: #848484;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  padding: 5px 0 12px 0;
}

.item .edit {
  background: #fff;
  margin-top: 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  line-height: 40px;
}

.item .edit .def {
  display: flex;
  align-items: center;
  margin-left: 12px;
  font-size: 14px;
}

.item .edit .def img {
  width: 13px;
  height: 13px;
}

.item .edit .btn-groups {
  display: flex;
  align-items: center;
  margin-right: 12px;
}

.item .edit .btn-groups .edit-btn {
  display: flex;
  align-items: center;
  margin-left: 15px;
}

.item .edit .btn-groups .edit-btn img {
  width: 10px;
  height: 10px;
}

.item .edit .btn-groups .edit-btn span {
  margin-left: 5px;
  font-size: 12px;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(74, 74, 74, 1);
}


/* 底部 */

.bottom {
  width: 100%;
  box-sizing: border-box;
  padding: 20px 15px;
  position: fixed;
  bottom: 0;
  left: 0;
  z-index: 10;
  background-color: #efeff4;
}

>>> .nut-button {
  background: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/components/device/userInfo/accounts/AgentList.vue